const indexItems = [
  { id: 1, title: '网红翻车实录', desc: '盘点近期翻车网红全记录', count: '32篇', icon: 'ri-alert-line', color: 'text-primary-600 bg-primary-50' },
  { id: 2, title: '明星塌房合集', desc: '娱乐圈最新塌房事件汇总', count: '28篇', icon: 'ri-building-2-line', color: 'text-accent-700 bg-accent-50' },
  { id: 3, title: '选秀黑幕深扒', desc: '选秀节目内幕与暗箱操作', count: '19篇', icon: 'ri-spy-line', color: 'text-primary-600 bg-primary-50' },
  { id: 4, title: '情感八卦专区', desc: '明星恋情分手复合全记录', count: '45篇', icon: 'ri-heart-line', color: 'text-accent-700 bg-accent-50' },
  { id: 5, title: '直播带货乱象', desc: '直播行业问题与消费陷阱', count: '24篇', icon: 'ri-shopping-bag-line', color: 'text-primary-600 bg-primary-50' },
  { id: 6, title: '综艺节目瓜田', desc: '综艺录制幕后花絮与爆料', count: '15篇', icon: 'ri-tv-line', color: 'text-accent-700 bg-accent-50' },
  { id: 7, title: '资本大瓜解密', desc: '商业大佬和资本圈八卦', count: '18篇', icon: 'ri-funds-line', color: 'text-primary-600 bg-primary-50' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              专题合集
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {indexItems.map((item) => (
              <div
                key={item.id}
                className="flex items-start gap-4 p-5 bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer group"
              >
                <div className={`flex-shrink-0 w-11 h-11 flex items-center justify-center rounded-lg ${item.color}`}>
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
                  <span className="inline-block mt-2 text-[10px] text-foreground-400 bg-background-100 px-2 py-0.5 rounded">
                    {item.count}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}